export default __webpack_public_path__ + "static/media/truck.97a5ddfa.svg";